import { fetchRoutesData } from "src/services/customSiteQueries";
import SitePage from "./page/site";
import { RouteConfig, RouteConfigComponentProps } from "react-router-config";

const header = [
  {
    "path": "/",
    "label": "Home"
  },
  {
    "path": "/dtdl-tech",
    "label": "Tech"
  },
  {
    "path": "/dtdl-life",
    "label": "Life"
  },
  {
    "path": "/joinus",
    "label": "JoinUs"
  },
  {
    "path": "/verticalcarousel",
    "label": "Vertical Carousel"
  },
  {
    "path": "/exp/*",
    "label": "Test Carousel"
  },
  {
    "path": "/:site",
    "label": "DTDL Page"
  }
]

export const fetchRoutes = async (): Promise<RouteConfig[]> => {
  try {
    console.log('route fetched=========> ',await fetchRoutesData())

    const data =  header;

    return data?.map((route: { path: string }) => ({
      path: route.path,
      exact: true,
      component: SitePage as React.ComponentType<
        RouteConfigComponentProps<any>
      >,
    }));
  } catch (error) {
    console.error("Error fetching routes:", error);
    return [];
  }
};
